import React, { Component } from 'react';
import axios from 'axios';
import withRouter from '../../Utils/withRouter';
import { convertTo12HourFormat, formatDate, SubmitButton } from '../../Components/InputElements';
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import Select from 'react-select';
import { NoRecords } from '../../Components/Shimmer';
import { decodeData } from '../../Constants/constants';

class TeamEmployees extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_id: 0,
            employee_attendance_id: 0,
            attendance_regularization_request_id: 0,
            modal_type: 1,
            location_id: '',
            department_id: '',
            designation_id: '',
            remark_by_employee: '',
            punch_in_datetime: "",
            punch_out_datetime: "",
            rows: [],
            logs_data: [],
            rz_data: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            loadingFilter: false,
            keyword: "",
            from_date: "",
            to_date: "",
            selectOption: "",
            department_rows: [],
            designation_rows: [],
            location_rows: [],
            selectedRows: [],
            decodedData: [],
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetDepartmentList();
            this.GetLocationList();
            // this.GetDesignationList();
            this.GetRegularizationSettings();
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    GetDepartmentList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAllMasters`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        department_rows: data.companies__departments.map((row) => ({
                            value: row.department_id,
                            label: row.department_title
                        }))
                    }));
                }
            });
    }

    // GetDesignationList = () => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Home/GetAllMasters`, { headers })
    //         .then((response) => {
    //             var data = response.data;
    //             if (response.data.success === true) {
    //                 console.log("data.companies__designations",data.companies__designations);
    //                 this.setState((prevState) => ({
    //                     designation_rows: data.companies__designations?.map((row) => ({
    //                         value: row.designation_id,
    //                         label: row.designation_title
    //                     }))
    //                 }));
    //             }
    //         });
    // }
    GetLocationList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAllMasters`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        location_rows: data.companies__locations.map((row) => ({
                            value: row.location_id,
                            label: row.location_title
                        }))
                    }));
                }
            });
    }

    GetRegularizationSettings = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationSettings`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true && data.length != 0) {
                this.setState({
                    rz_data: data[0],
                });
            }
        });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Approver/GetMyTeamEmployees`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                attendance_status: this.state.selectOption,
                location_id: this.state.location_id,
                department_id: this.state.department_id,
                designation_id: this.state.designation_id
            },
            headers,
        })
            .then((response) => {
                const data = response.data;
                if (response.data.success === true) {
                    this.setState({
                        rows: data.data,
                        next: data.next,
                        prev: data.prev,
                        page: data.page,
                        total_records: data.total_records,
                        total_pages: data.total_pages,
                    });
                }
                this.setState({ loadingList: false, loadingFilter: false });
            })
            .catch((error)=>{
                this.setState({ loadingList: false, loadingFilter: false });
                Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: error?.message, 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
                });
            });
    };


    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Attendance/GetMyTeamAttendance`, {
            params: {
                limit: this.state.total_records,
                page: 1,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                attendance_status: this.state.selectOption,
                location_id: this.state.location_id,
                department_id: this.state.department_id,
                designation_id: this.state.designation_id
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response.data.data;

                const data = this.state.rows.map(row => ({
                    'Employee Code': row.employee_code,
                    'Employee Name': row.employee_name,
                    'Employee Personal Email': row.employee_email_address,
                    'Employee Official Email': row.employee_official_email,
                    'Designation': row.designation_title,
                    'Location': row.location_title,
                    'Department': row.department_title,
                    'Shift': `${convertTo12HourFormat(row.shift_start_time)} - ${convertTo12HourFormat(row.shift_end_time)}`
                }));

                const columns = [
                    { header: 'Employee Code', key: 'Employee Code', width: 30 },
                    { header: 'Employee Name', key: 'Employee Name', width: 30 },
                    { header: 'Employee Personal Email', key: 'Employee Personal Email', width: 30 },
                    { header: 'Employee Official Email', key: 'Employee Official Email', width: 30 },
                    { header: 'Designation', key: 'Designation', width: 30 },
                    { header: 'Location', key: 'Location', width: 30 },
                    { header: 'Department', key: 'Department', width: 30 },
                    { header: 'Shift', key: 'Shift', width: 30 },
                ];


                const wb = XLSX.utils.book_new();

                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });

                ws['!cols'] = columns.map(column => ({ wch: column.width }));

                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });

                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });

                XLSX.utils.book_append_sheet(wb, ws, 'AbStart My Team Employees');

                const date = new Date();
                const dateString = date.toLocaleDateString();
                const timeString = date.toLocaleTimeString();

                XLSX.writeFile(wb, `AbStartMyTeamEmployees_(${formatDate(dateString)} ${timeString}).xlsx`);

                Swal.close();

                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        })
            .catch((error) => {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    }

    handleInputSearch = () => {
        this.setState(
            {
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page - 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleNext = () => {
        if (this.state.next === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page + 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleChange = (e) => {
        this.setState(
            (prevState) => {
                return { page: parseInt(e.target.value, 10) };
            },
            () => {
                this.GetList();
            }
        );
    };

    handleClearAll = () => {
        this.setState(
            {
                rows: [],
                next: false,
                prev: false,
                page: 1,
                limit: 10,
                total_records: 0,
                total_pages: 0,
                loadingList: false,
                keyword: "",
                from_date: "",
                to_date: "",
                selectOption: '',
                location_id: '',
                department_id: '',
                designation_id: '',
            },
            () => {
                this.GetList();
            }
        );
    };

    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
        return (

            this.state.loadingList === false ?
                (<div className="main-content">
                    <div className='page-content'>
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Team Employees`} primary={`Team Employees`} path={`/TeamEmployees`} />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                <div className='col-md-3'>
                                                    <label htmlFor="keyword">Enter Name</label>
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by Name" />
                                                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                    </div>
                                                </div>
                                                <div className='col-md-3 position-relative mb-5'>
                                                    <div><label>Location</label></div>
                                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                                                        options={this.state.location_rows}
                                                        placeholder={`Select Location`}
                                                        value={this.state.location_id ? this.state.location_rows.find((option) => option.value === this.state.location_id) : null}/>
                                                    </div>
                                                </div>
                                                <div className='col-md-3 position-relative mb-5'>
                                                    <div><label>Department</label></div>
                                                    <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                                                        options={this.state.department_rows}
                                                        placeholder={`Select Department`}
                                                        value={this.state.department_id ? this.state.department_rows.find((option) => option.value === this.state.department_id) : null}/>
                                                    </div>
                                                </div>
                                                {/* <div className='col-md-3'>
                                                    <div>
                                                        <label>Designation</label>
                                                    </div>
                                                    <Select
                                                        onChange={(selectedOption) => this.handleSelectChange('designation_id', selectedOption)}
                                                        placeholder={`Select Designation`}
                                                        options={this.state.designation_rows}
                                                        value={this.state.designation_id ? this.state.designation_rows.find((option) => option.value === this.state.designation_id) : null}
                                                    />
                                                </div> */}
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Apply Filter</label></div>
                                                    {/* <button
                                                        type="button"
                                                        onClick={this.handleInputSearch}
                                                        className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && this.state.location_id === '' && this.state.department_id === '' && this.state.designation_id === '') ? 'disabled' : ''}`}>
                                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                        Filter
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                                    disabled={!this.state.keyword && !this.state.location_id && !this.state.department_id && !this.state.designation_id}
                                                    loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                    buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                </div>
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Clear Filter</label></div>
                                                    {/* <button
                                                        type="button"
                                                        className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && this.state.location_id === '' && this.state.department_id === '' && this.state.designation_id === '') ? 'disabled' : ''}`}
                                                        onClick={this.handleClearAll}>
                                                        <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i> 
                                                        Clear
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                    disabled={!this.state.keyword && !this.state.location_id && !this.state.department_id && !this.state.designation_id}
                                                    loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                                    buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                </div>
                                                {this.state.decodedData?.includes(6) && (
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Export Excel</label></div>
                                                    {this.state.decodedData?.includes(6) && (
                                                    // <button
                                                    //     type="button"
                                                    //     onClick={this.handleExcelDownload}
                                                    //     className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                                    //     <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                    //     Export Excel
                                                    // </button>
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                    disabled={this.state.rows.length === 0}
                                                    buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                )}
                                                </div>)}
                                            </div>

                                        </div>

                                        <div className="card-body">
                                            <div className='card mt-3'>
                                                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                    <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                        <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                            <tr>
                                                                <th className='noWrap'>Employee Code</th>
                                                                <th className='noWrap'>Employee Name</th>
                                                                <th className='noWrap'>Personal email</th>
                                                                <th className='noWrap'>Official email</th>
                                                                <th>Designation</th>
                                                                <th>Location</th>
                                                                <th>Department</th>
                                                                <th>Shift</th>
                                                            </tr>
                                                        </thead>
                                                        {this.state.rows.length === 0 ? (
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={15}>
                                                                        <NoRecords />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        ) :
                                                            <tbody>
                                                                {this.state.rows.map((row) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{row.employee_code}</td>
                                                                            <td>{row.employee_name}</td>
                                                                            <td>{row.employee_email_address}</td>
                                                                            <td>{row.employee_official_email}</td>
                                                                            <td>{row.designation_title}</td>
                                                                            <td>{row.location_title}</td>
                                                                            <td>{row.department_title}</td>
                                                                            <td className='noWrap'>{convertTo12HourFormat(row.shift_start_time)} - {convertTo12HourFormat(row.shift_end_time)}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>}
                                                    </table>
                                                </div>
                                                <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2">
                                                    {/* <button
                                                        disabled={this.state.prev === false && this.state.loadingList === false}
                                                        type="button"
                                                        onClick={() => this.handlePrev()}
                                                        className={`btn btn-warning btn-label waves-effect waves-light`}
                                                    >
                                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                        Previous
                                                    </button> */}
                                                    <SubmitButton onClick={()=>{ this.handlePrev() }} 
                                                    disabled={this.state.prev === false && this.state.loadingList === false}
                                                    buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                                                    <SubmitButton otherClasses='d-md-none d-block' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                                    disabled={this.state.next === false && this.state.loadingList === false}
                                                    buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                                    {/* <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false } type="button" onClick={() => this.handleNext()} 
                                                    className={` d-md-none d-block btn btn-primary btn-label waves-effect right waves-light`}>
                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                        Next
                                                    </button> */}
                                                    <div className="col-md-4 col-12 my-md-0 my-2" style={{ display: "flex", alignItems: "center" }} >
                                                        {
                                                            <small>
                                                                Total Records: {this.state.total_records} |
                                                                Total Pages: {this.state.total_pages} |
                                                                Current Page: {this.state.page}
                                                            </small>
                                                        }
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                            {Array.from({ length: this.state.total_pages },
                                                                (_, i) => (<option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                            {limitOptions.map((option) => (
                                                                <option key={option} value={option}>
                                                                    Limit {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false } type="button" onClick={() => this.handleNext()} 
                                                    className={` d-md-block d-none btn btn-primary btn-label waves-effect right waves-light`}>
                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                        Next
                                                    </button> */}
                                                    <SubmitButton otherClasses='d-md-block d-none' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                                    disabled={this.state.next === false && this.state.loadingList === false}
                                                    buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

        );
    }
}

export default withRouter(TeamEmployees);